// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2OAxQ","insightsList":"newBusinessInsightsMenu_insightsList__2iNec","active":"newBusinessInsightsMenu_active__2tf2A"};